import { createAction, props } from '@ngrx/store';

export const noopAction = createAction('[core] noop');
export const showToast = createAction('[core] show Toast', props<{ key: string; success?: boolean }>());

